import { render, staticRenderFns } from "./StDownloadList.vue?vue&type=template&id=1545001a"
import script from "./StDownloadList.vue?vue&type=script&lang=ts"
export * from "./StDownloadList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports